import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { CreateDashboard, GetGraphByUserId } from './../../../reduxToolkit/Graphs/GraphsApi';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const FunctionalityAddDashboard = ({ onHide }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticatioauthennSlice.getUserByIdAtEntry.userId);
    // State hooks to manage dashboard creation process
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [dashboardName, setDashboardName] = useState('');
    const [getAvailable, setGetAvailable] = useState(false);
    const [availablePosition, setAvailablePosition] = useState(null);
    const [data, setData] = useState(null);
    const [showError, setShowError] = useState(false);

    // Fetches existing dashboards for the user when component mounts
    useEffect(() => {
        dispatch(GetGraphByUserId(userId)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setData(data);
                }
            },
        );
    }, [dispatch]);
    // Determines the next available dashboard position
    useEffect(() => {
        if (data) {
            const usedPositions = new Set(data.map((item) => item.number));
            let position = 1;
            while (usedPositions.has(position)) {
                position++;
            }
            setAvailablePosition(position);
        }
    }, [data, getAvailable]);

    // Handles dashboard creation and updates the dashboard list
    const handleCreate = async () => {
        if (!dashboardName) {
            setShowError(true);
            toast.warn(t('please_fill_all_fields'));
            return;
        }
        if (availablePosition === null) {
            return;
        }

        const body = {
            name: dashboardName,
            number: availablePosition,
            templateId: selectedTemplate,
            userId: userId,
        };

        const result = await dispatch(CreateDashboard({ body }));
        const {
            data: { success },
        } = result.payload;

        if (success === true) {
            toast.success(t('has_been_created_successfully'));
            dispatch(GetGraphByUserId(userId)).then(() => {
                onHide();
            });
        }
    };

    // Handles template selection from radio buttons
    const handleRadioChange = (e) => {
        const id = e.target.value;
        setSelectedTemplate(id);
        setGetAvailable(true);
    };

    return {
        handleCreate,
        t,
        dashboardName,
        showError,
        setDashboardName,
        selectedTemplate,
        handleRadioChange,
    };
};
export default FunctionalityAddDashboard;
